import React from 'react';
import { Button } from '../Button';
import { FileText, Bot, Eye, Wand2, FolderOpen, ClipboardPlus } from 'lucide-react';

interface PlanToolbarProps {
  onOpenWizard: () => void;
  onOpenStempelfeld: () => void;
  onOpenAnalysis: () => void;
  /** Die Projektablage (Modul Dokumente) mit der Ansicht fuer den SiGe-Plan. */
  onOpenDokumente: () => void;
  onExportPDF: () => void;
  /**
   * Einen direkt vom Rechner geplotteten Plan nachtragen (zaehlt gegen die
   * Papierrolle). Ohne Handler kein Knopf — erst mit angelegtem Plan.
   */
  onDruckNachtragen?: () => void;
}

export const PlanToolbar: React.FC<PlanToolbarProps> = ({ onOpenWizard, onOpenStempelfeld, onOpenAnalysis, onOpenDokumente, onExportPDF, onDruckNachtragen }) => {
  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <Button variant="ghost" onClick={onOpenWizard} className="text-sm text-violet-700 hover:text-violet-800 hover:bg-violet-50" title="Geführte Anlage in sechs Schritten">
        <Wand2 className="w-4 h-4 mr-2" />
        Assistent
      </Button>
      <Button variant="ghost" onClick={onOpenStempelfeld} className="text-sm">
        <FileText className="w-4 h-4 mr-2" />
        Plankopf / Projektdaten
      </Button>
      <Button variant="ghost" onClick={onOpenAnalysis} className="text-sm text-blue-600 hover:text-blue-700 hover:bg-blue-50">
        <Bot className="w-4 h-4 mr-2" />
        KI-Analyse
      </Button>
      <Button variant="ghost" onClick={onOpenDokumente} className="text-sm text-indigo-600 hover:text-indigo-700 hover:bg-indigo-50" title="Pläne, Verträge und Nachweise aus der Projektablage">
        <FolderOpen className="w-4 h-4 mr-2" />
        Dokumente
      </Button>
      <div className="w-px h-6 bg-slate-200 mx-2" />
      <Button data-tutorial="sigeplan.vorschau-export" variant="ghost" onClick={onExportPDF} className="text-sm">
        <Eye className="w-4 h-4 mr-2" />
        Vorschau & Export
      </Button>
      {onDruckNachtragen && (
        <Button variant="ghost" onClick={onDruckNachtragen} className="text-sm" title="Einen direkt vom Rechner geplotteten Plan nachtragen, zählt gegen die Papierrolle">
          <ClipboardPlus className="w-4 h-4 mr-2" />
          Druck nachtragen
        </Button>
      )}
    </div>
  );
};
